export default "__VITE_ASSET__dbb6c60c__"